import { render, staticRenderFns } from "./approval_cc_to_me.vue?vue&type=template&id=5861c034"
import script from "./approval_cc_to_me.vue?vue&type=script&lang=js"
export * from "./approval_cc_to_me.vue?vue&type=script&lang=js"
import style0 from "./approval_cc_to_me.vue?vue&type=style&index=0&id=5861c034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports